
import request from '@/utils/server'
 
//  组织列表
export function getOrgList(query) {
    return request({
      url: '/user/getOrgList',
      method: 'get',
      params: query
    })
  }
// 新增组织
export function addOrg(data) {
    return request({
      url: '/user/addOrg',
      method: 'POST',
      data:data
    })
  }
  // 删除
  export function delOrg(data) {
    return request({
      url: '/user/delOrg',
      method: 'POST',
      data:data
    })
  }
  // 修改
  export function editOrg(data) {
    return request({
      url: '/user/editOrg',
      method: 'POST',
      data:data
    })
  }